import { ConsoleLogger } from "@fideus/logger";
import type { ErrorInfo } from "react";
import { getPosthog } from "./providers/posthogSingleton";

const logger = new ConsoleLogger();

export function reportErrorToPosthog(error: unknown, info?: ErrorInfo) {
  const posthog = getPosthog();
  if (posthog) {
    posthog.captureException(error, { $error_info: info });
  } else {
    logger.info("Uncaught error:", error, info);
  }
}
